import type { Schemas } from "./api/client";

/** CSS suffix for source-controlled school lessons; manual appointment titles do not imply a school change. */
export function timetableClasses(source: Schemas["ChangeSource"] | undefined, title: string): string {
  if (source !== "web_untis") return "";
  const change = title.startsWith("Entfällt: ") ? " timetable-cancelled"
    : title.startsWith("Geändert: ") ? " timetable-changed" : "";
  return " timetable-event" + change;
}

export function timetableChange(source: Schemas["ChangeSource"] | undefined, title: string): "changed" | "cancelled" | null {
  if (source !== "web_untis") return null;
  return title.startsWith("Entfällt: ") ? "cancelled" : title.startsWith("Geändert: ") ? "changed" : null;
}

/** Nur bekannte Fachnamen kürzen; Originaltitel bleibt im zugänglichen Namen und in den Details. */
export function schoolShortTitle(title: string): string {
  const subject = title.replace(/^(Geändert|Entfällt): /, "");
  const names: Record<string, string> = {
    Mathematik: "Mathe", Deutsch: "Deutsch", Englisch: "Engl.", Französisch: "Franz.",
    Geschichte: "Gesch.", Geographie: "Geo", Biologie: "Bio", Physik: "Physik",
    Chemie: "Chemie", Religionslehre: "Religion", "Katholische Religion": "Kath. Rel.",
    "Evangelische Religion": "Ev. Rel.", "Natur und Technik": "NuT", Informatik: "Info",
    "Wirtschaft und Recht": "WiR", Kunsterziehung: "Kunst", Klassenlehrerstunde: "Klassenst.",
  };
  return names[subject] ?? subject;
}

export function schoolDetails(description: string | null): { label: string; value: string }[] {
  const labels = ["Fächer", "Ursprüngliche Fächer", "Räume", "Ursprüngliche Räume", "Lehrer", "Ursprüngliche Lehrer", "Unterrichtstext", "Vertretungstext", "Information", "Schülergruppe", "Unterrichtsart"];
  return (description ?? "").split("\n").flatMap((line) => {
    const separator = line.indexOf(": ");
    const label = line.slice(0, separator);
    if (!labels.includes(label)) return [];
    return [{ label, value: line.slice(separator + 2).replace(/Nicht aufgelöst \(#\d+\)/g, "Name nicht verfügbar") }];
  });
}
